import { baseUrl } from '../../config/env'
export function interceptorsRequest(config) {
  return config
}

export function interceptorsResponse(response) {
  console.log('拦截器数据', response)
  if (response.status === 200 || response.status === 201) {
    const data = response.data
    if (data.err === '403') {
      window.location.href = `${baseUrl}/cas/login`
    } else {
      return data
    }
  }
}
